import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useHistory } from "react-router";

import { ProfileDataTab } from "src/app/Task/tabs/ProfileDataTab/ProfileDataTab";
import { SocialProfile } from "src/app/modals/AddSocialProfilesModal/AddSocialProfilesModal";
import { deleteSearchParamIfExists } from "src/utils/methods";
import { ProfileData } from "src/types/social-data/profileData";
import Tabs from "../Tabs/Tabs";
import { ProfileTab } from "../GlobalTaskDetails/tabs/GlobalTaskSocialData/GlobalTaskSocialData";
import Tab from "../Tabs/Tab";
import { gallerySocialProviders } from "../Gallery/components/GalleryFiltersDropdown/utils";
import { PublicationsStream } from "../PublicationsStream/PublicationsStream";

import "./SocialData.scss";

interface SocialDataProps {
  providers: ProfileTab[];
  socialProfiles: SocialProfile[];
  profileNotFound: boolean;
  userSocialProviderIsNotCrawlable: boolean;
  selectedProvider: ProfileTab;
  data: {
    uuid: string;
    title: string;
  };
  profileData: ProfileData | null;
  setSelectedProvider: Dispatch<SetStateAction<ProfileTab>>;
}

export function SocialData({
  providers,
  selectedProvider,
  data,
  setSelectedProvider,
  socialProfiles,
  profileData,
  profileNotFound,
  userSocialProviderIsNotCrawlable,
}: SocialDataProps) {
  const [publicationsStreamShowMore, setPublicationsStreamShowMore] =
    useState(false);

  const shouldDisplayPublicationsStream = useMemo(() => {
    return (
      socialProfiles.filter((item) =>
        gallerySocialProviders.find(
          (provider) => provider.value === item.socialProvider.replace("_", ""),
        ),
      ).length > 0
    );
  }, [socialProfiles]);

  const history = useHistory();

  useEffect(() => {
    deleteSearchParamIfExists({
      key: "galleryShowMoreByDefault",
      history,
      callback: () => {
        setPublicationsStreamShowMore(true);
      },
    });
  }, [window.location.search]);

  return (
    <div className="social-data">
      {shouldDisplayPublicationsStream && (
        <PublicationsStream
          socialProfiles={socialProfiles}
          showMore={publicationsStreamShowMore}
          setShowMore={setPublicationsStreamShowMore}
          profileData={profileData}
        />
      )}

      {!publicationsStreamShowMore && (
        <>
          <Tabs>
            {providers.map((tab) => (
              <Tab
                tabText={tab.label}
                active={selectedProvider.value === tab.value}
                onClick={() => setSelectedProvider(tab)}
              />
            ))}
          </Tabs>

          <ProfileDataTab
            socialProfiles={socialProfiles}
            profileData={profileData}
            selectedSocialProvider={selectedProvider}
            profileNotFound={profileNotFound}
            userSocialProviderIsNotCrawlable={userSocialProviderIsNotCrawlable}
            hasAnySocialProfile
            taskTitle={data.title}
            taskId={data.uuid}
          />
        </>
      )}
    </div>
  );
}
